<template>
  <el-table-column
    prop="country.name"
    label="Ország"
    show-overflow-tooltip
    min-width="150"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.address && scope.row.address.country && scope.row.address.country.name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'country.name',
  };
</script>
